export default "__VITE_ASSET__C72PHG6U__"